/* eslint-disable max-classes-per-file */
import { ProjectStatus } from '@projects/models/project';
import { type QueryFilters as TanstackQueryFilters } from '@tanstack/react-query';
import { QueryType } from 'src/new_arch/queries/types';

class QueryKeys {
	static forProjects( { status }: { status: ProjectStatus } ) {
		return [ 'projects', { status } ];
	}

	static forProjectCounts() {
		return [ 'projects', 'counts' ];
	}

	static forProjectMembers( { projectID }: { projectID: number } ) {
		return [ 'projects', projectID, 'members' ];
	}

	static forIncludedFeatures( projectID: number ) {
		return [ 'projects', projectID, 'included_features' ];
	}

	static forGuestHashes( projectID: number ) {
		return [ 'projects', projectID, 'guest_hashes' ];
	}
}

class QueryFilters {
	static forProjectLists(): TanstackQueryFilters {
		return {
			type: 'active',
			predicate: ( { queryKey: key } ) => (
				key[ 0 ] === 'projects'
				&& ( key[ 1 ] === 'active' || key[ 2 ] === 'hidden' )
			)
		};
	}

	static forIncludedFeatures(
		projectID?: number,
		{ type }: { type?: QueryType } = {}
	): TanstackQueryFilters {
		return {
			type,
			predicate: ( { queryKey: key } ) => (
				key[ 0 ] === 'projects'
				&& ( !projectID || key[ 1 ] === projectID )
				&& key[ 2 ] === 'included_features'
			)
		};
	}
}

export { QueryKeys, QueryFilters };
